import { isDefined } from "@clipboard-health/util-ts";
import { isBefore } from "date-fns";

export type GeofenceTimestampType = "exact" | "plausible";

export function getEffectiveGeofenceArrival(
  geofenceArrivalTime?: Date,
  earliestPlausibleArrivalTime?: Date,
  isEnforceGeofenceTimestampsEnabled = false
): {
  type: GeofenceTimestampType;
  value: Date | undefined;
} {
  const isArrivalBeforeEpat =
    isDefined(earliestPlausibleArrivalTime) &&
    isDefined(geofenceArrivalTime) &&
    isBefore(geofenceArrivalTime, earliestPlausibleArrivalTime);
  const timestampType =
    isEnforceGeofenceTimestampsEnabled && !isArrivalBeforeEpat ? "plausible" : "exact";

  const timestamp = timestampType === "exact" ? geofenceArrivalTime : earliestPlausibleArrivalTime;

  return {
    type: timestampType,
    value: timestamp,
  };
}
